// Custom packages
import { environment } from "../../../environments/environment";

/**
 * Key of the environment files that shows Arturo's entries in the sidebar: «Carica documenti» and
 * «Caricamenti», for the roles holding `arturo:use`.
 *
 * Arturo has a switch of its own on the back-end (`ARTURO_ENABLED`): while it is off its routes do not
 * exist and every call answers 404. The permission alone cannot hide the entries, since it is already
 * granted to the admin and operator roles of both databases (26/10). So the key goes into a build only
 * when the module is on for the API that build talks to.
 *
 * Since 29/10 it is in environment.staging.ts, with the module turned on in staging for the first look
 * at the pages, and in environment.local.ts (`npm run start:local`), by Francesco's choice: that build
 * talks to the production API, where the module is off, so the pages show and Arturo's calls answer
 * that the module is not active. environment.prod.ts gets it when the module is turned on in
 * production; until then the spec keeps it out.
 *
 * @since 3.0.0
 */
export const ARTURO_LIVE_KEY = "arturoLive";

/**
 * Whether the given environment shows Arturo's entries. Only the boolean `true` does: a missing key,
 * `false`, or any other value — the string "true" included — keeps them hidden.
 *
 * @since 3.0.0
 */
export function arturoLiveIn(env: { [key: string]: unknown } | null | undefined): boolean {
  return !!env && env[ARTURO_LIVE_KEY] === true;
}

/**
 * Whether this build shows Arturo's entries, @see ARTURO_LIVE_KEY
 *
 * @since 3.0.0
 */
export function isArturoLive(): boolean {
  return arturoLiveIn(environment);
}
